import type {
  IFilterSet,
  ILimitedDateFilter,
  IMultiSelectFilter,
  ISingleSelectFilter,
} from '@user/components/Filters'
import type { ActivityStatus } from '../constants'
import type { ENTITY_TYPES } from '@sales-center/common'

export enum ActivityOverdue {
  Overdue = 'Overdue',
}

export type ActivitySummaryTab = ActivityStatus | ActivityOverdue

//#region DTO / Filter typings

export type ActivitySummaryDTO = {
  id: number
  subject: string | null
  description: string | null
  owner: string | null
  ownerId: string | null
  activityType: string
  activityTypeId: string
  status: ActivityStatus
  // SH-2338: an activity need not be attached to a lead or opportunity. When it
  // is not, it has no record to inherit a funnel, team or name from.
  salesFunnelId: number | null
  salesTeamId: number | null
  salesTeamIds: number
  createdDate: string
  startDate: string | null
  dueDate: string
  entityId: number | null
  entityType: 'Lead' | 'Opportunity' | null
  relatedTo: string
}

export type ActivitySummaryRow = Omit<
  ActivitySummaryDTO,
  'createdDate' | 'startDate' | 'dueDate' | 'entityType'
> & {
  dueDate: Date | string
  createdDate: Date | string
  startDate: Date | null | string
  entityType: ENTITY_TYPES | null
}

export interface ActivitySummaryFilterSet
  extends IFilterSet<ActivitySummaryDTO> {
  filters: {
    activityTypeId: ISingleSelectFilter<ActivitySummaryDTO>
    ownerId: IMultiSelectFilter<ActivitySummaryDTO>
    createdDate: ILimitedDateFilter<ActivitySummaryDTO>
    dueDate: ILimitedDateFilter<ActivitySummaryDTO>
    startDate: ILimitedDateFilter<ActivitySummaryDTO>
    salesFunnelId: ISingleSelectFilter<ActivitySummaryDTO>
    salesTeamIds: IMultiSelectFilter<ActivitySummaryDTO>
  }
}

//#endregion

//#region Top Stats typings

export type ActivitySummaryTopStatsDTO = {
  toDoTotalCount: number
  inProgressTotalCount: number
  deferredTotalCount: number
  completeTotalCount: number
  toDoPercentage: number
  inProgressPercentage: number
  deferredPercentage: number
  avgTimeToCompletion: number
}

export type ActivitySummaryDateFilter =
  | 'Last7Days'
  | 'Last30Days'
  | 'Last90Days'

export type ActivitySummaryTopStatsInput = {
  activityTypeId?: number
  activityOwnerIds?: (string | null)[]
  createdDateFilter?: ActivitySummaryDateFilter
  startDateFilter?: ActivitySummaryDateFilter
  dueDateFilter?: ActivitySummaryDateFilter
  salesFunnelId?: number
  salesTeamIds?: number[]
}

//#endregion
